import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Dayjs } from 'dayjs'
import { useMemo } from 'react'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { StatusPill } from 'screens/Schedule/ScheduleStatusBanner/StatusPill'

dayjs.extend(utc)

interface ScheduleStatusPillPostingProps {
  startDate?: Dayjs
}

export const ScheduleStatusPillPosting = ({ startDate }: ScheduleStatusPillPostingProps) => {
  const workspace = useCurrentWorkspace()

  const label = useMemo(() => {
    const isApprovalsEnabled = !!workspace?.post_approval_enabled
    const daysUntil = dayjs.utc(startDate).startOf('day').diff(dayjs.utc().startOf('day'), 'day')

    if (isApprovalsEnabled) return 'Posting'
    if (daysUntil > 5) return `Posting on ${startDate?.format('MMM D')}`
    if (daysUntil < 1) return 'Posting today'
    if (daysUntil < 2) return 'Posting tomorrow'
    return `Posting in ${daysUntil} days`
  }, [startDate, workspace?.post_approval_enabled])

  return <StatusPill status="posting">{label}</StatusPill>
}
